
const getOrderId = orderString => `MUS${"0000000".slice(0, 7 - orderString.length)}${orderString}`

const formatOrderSupplier = o => ({
  Order: { value: o.Order, isLink: true, uuid: o.OrderUUID },
  ExternalCode: { value: o.ExternalCode },
  Product: { value: o.Product },
  BookingDate: o.BookingDate
    ? { value: o.BookingDate, isDate: true }
    : { value: "" },
  ProductDate: o.ProductDate
    ? { value: o.ProductDate, isDate: true }
    : { value: "" },
  Feature: { value: o.Feature },
  Holder: { value: o.Holder },
  NetPrice: {
    value: o.Status === 'BOOKING_CONFIRMED' ? o.SellerPrice: "",
    isPrice: true,
    currency: o.Currency
  },
  LastName: { value: o.LastName },
  Status: { value: o.Status, isStatus: true }
})


const formatOrderAffiliate = o => ({
  Order: { value: o.Order, isLink: true },
  ExternalCode: { value: o.ExternalCode },
  Product: { value: o.Product },
  BookingDate: o.BookingDate
    ? { value: o.BookingDate, isDate: true }
    : { value: "" },
  ProductDate: o.ProductDate
    ? { value: o.ProductDate, isDate: true }
    : { value: "" },
  Feature: { value: o.Feature },
  Holder: { value: o.Holder },
  RetailPrice: {
    value: o["Retail Price"],
    isPrice: true,
    currency: o.Currency
  },
  "Margin without VAT": {
    value: o["Gross Margin NetVat"],
    isPrice: true,
    currency: o.Currency
  },
  LastName: { value: o["Last Name"] },
  Status: { value: o.BookingStatus, isStatus: true }
})

const formatOrderAgent = o => ({
  Order: { value: o.Order, isLink: true, uuid: o.OrderUUID },
  Product: { value: o.Product },
  BookingDate: o.BookingDate
    ? { value: o.BookingDate, isDate: true }
    : { value: "" },
  ProductDate: o.ProductDate
    ? { value: o.ProductDate, isDate: true }
    : { value: "" },
  Holder: { value: o.Holder },
  RetailPrice: {
    value: o.RetailPrice,
    isPrice: true,
    currency: o.Currency
  },
  LastName: { value: o.LastName },
  Email: { value: o.Email },
  Status: { value: o.Status, isStatus: true }
})

const formatCSVColumnsSupplier = orders => {
  const formattedOrders = JSON.parse(JSON.stringify(orders));
  formattedOrders.forEach(o => {
    delete o.Discounted;
    delete o.Transacted;
    o.Commissions = o.GrossMargin;
    o.NetPrice = o.Status === 'BOOKING_CONFIRMED' ? o.SellerPrice : '';
    delete o.GrossMargin;
    delete o.SellerPrice;
    delete o.RetailPrice;
    delete o.Commissions;
    delete o.Email;
  });

  return formattedOrders;
}

const formatCSVColumnsAffiliate = orders => {
  const formattedOrders = JSON.parse(JSON.stringify(orders));
  return formattedOrders.map(o => ({
    Country: o["Country Host"],
    "Order id": getOrderId(o.Order),
    "Product names": o.Product,
    "Product dates": o.ProductDate,
    "Product valid until": o.ProductValidUntil,
    "Product cities": o.CityProduct,
    "Product countries": o.CountryProduct,
    Created: o.BookingDate,
    Status: o.BookingStatus,
    "Total quantity": o.Tickets,
    "Affiliate Channel": o.AffiliateChannel,
    Price: o["Retail Price"],
    Margin: o["Gross Margin NetVat"],
    "Frontend source": o.Source,
    LastName: o["Last Name"]
  }));
}

const formatCSVColumnsAgent = orders => {
  const formattedOrders = JSON.parse(JSON.stringify(orders));
  formattedOrders.forEach(o => {
    delete o.Discounted;
    delete o.Transacted;
    o.Commissions = o.GrossMargin;
    o.NetPrice = o.SellerPrice;
    delete o.GrossMargin;
    delete o.SellerPrice;
    delete o.Email;
  });

  return formattedOrders;
}


const formatOrder = {
  supplier: formatOrderSupplier,
  affiliate: formatOrderAffiliate,
  agent: formatOrderAgent
}

const formatCSVColumns = {
  supplier: formatCSVColumnsSupplier,
  affiliate: formatCSVColumnsAffiliate,
  agent: formatCSVColumnsAgent
}


export { 
  formatOrder, 
  formatCSVColumns, 
  getOrderId 
}
